import React, { useEffect, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import * as CONSTANTS from "../CONSTANTS";
import './home.css';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

function HomeScreen() {
    
    const [magazines, setMagazines]                                        = useState([]);

    const swiperRef                                                        = useRef(null);

    useEffect(() => {
        collectMagazineList()
    },[])

    const collectMagazineList = async () => {

        try {
             const response = await axios.get(CONSTANTS.API_URL + "api.php?scriptlist="+ CONSTANTS.ACCESSCODE);
            // console.log(response.data);
            setMagazines(response.data.scripts)
        }catch(err){
            console.log(err);
        }
    }

  return (
    <div className="main-place-area">
        <div className="top-nav-layer" ></div>
            <div className="body-area-layer">
                <div className="container">
                    {
                        magazines.length > 0 && (
                            <>
                                <Swiper
                                    ref={swiperRef}
                                    effect="coverflow"
                                    grabCursor={true}
                                    centeredSlides={true}
                                    loop={true}
                                    slidesPerView="auto"
                                    coverflowEffect={{
                                        rotate: 0,
                                        stretch: 0,
                                        depth: 100,
                                        modifier: 2.5,
                                        slideShadows: false
                                    }}
                                    pagination={{ clickable: true }}
                                    navigation={true}
                                    modules={[EffectCoverflow, Navigation]}
                                    className="swiper_container"
                                >
                                    {
                                        magazines.map((mag, index) => (
                                            <SwiperSlide key={index}>
                                                <div className="label-name-titling">
                                                    <strong># {mag.number}</strong>) {mag.title}
                                                </div>
                                                <img src={mag.featuredImage} alt={mag.title} />
                                                <div>
                                                    <Link
                                                        to={`/magazine/${mag.number}`}
                                                        className="btn btn-main btn-act"
                                                    >
                                                        Open
                                                    </Link>
                                                </div>
                                            </SwiperSlide>
                                        ))
                                    }
                                </Swiper>

                               
                            </>
                        )
                    }
                </div>
            </div>
        </div>
  )
}

export default HomeScreen